<template>
  <div class="LogSignCard">
    <div class="flex-jc-ard title" style="margin-right: 200px">
      <div :class="{'sp-color-1':type=='logIn'}" class="pointer" @click="changeType('logIn')">{{ $l('login') }}</div>
      <div :class="{'sp-color-1':type=='signUp'}" class="pointer" @click="changeType('signUp')">{{ $l('signup') }}</div>
    </div>
    <div class="content">
      <div class="input">
        <div v-if="type=='logIn'">
          <div class="flex-al-start" style="display: flex">
            <div class="flex-1">
              <table class="table" border="0" cellpadding="0" cellspacing="0">
                <tr class="row">
                  <td class="flex flex-al-center">
                    <sp-icon type="user" :size="20" />
                    <sp-input v-model="logInfo.account" type="none" height="60" :width="0.9" :placeholder="$l('userId')" @blur="searchAdmins" />
                  </td>
                </tr>
                <tr class="row">
                  <td class="flex flex-al-center">
                    <sp-icon type="lock" :size="20" />
                    <sp-input v-model="logInfo.password" height="60" password type="none" :width="0.9" :placeholder="$l('password')" show-password="true" />
                  </td>
                </tr>
                <tr class="row">
                  <td class="flex flex-al-center">
                    <sp-icon type="shield" :size="20" />
                    <sp-input v-model="logInfo.captchaCode" type="none" :width="0.5" :placeholder="$l('verifyCode')" />
                    <!-- <sp-identify :content-width="110" :content-height="40" :identify-code="verifyCode" /> -->
                    <img class="pointer" :src="verifiCodeImg" width="140" height="60" @click="changeCode">
                  </td>
                </tr>
                <tr>
                  <td class="forget" align="left">
                    <span class="pointer sp-color-1" @click="forgetPass=!forgetPass">{{ $l('forgetPass') }}</span>
                  </td>
                </tr>
              </table>
            </div>
            <div v-if="isEnterprise && hrAdmins.length > 0" style="width: 200px" class="hr-panel text-left">
              <div>
                <span>{{ $l('HrName') }}</span>
                <SpSelect v-model="logInfo.supervisorId" type="none" height="45" :width="200" :need-search="false">
                  <SpSelectOption v-for="hr in hrAdmins" :key="hr.id" :label="hr.fullName" :value="hr.id" />
                </SpSelect>
              </div>
              <div style="margin-top: 20px">
                <span>{{ $l('HRPasswords') }}</span>
                <sp-input v-model="logInfo.supervisorPwd" password type="none" height="45" :width="200" show-password="true" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="type=='signUp'">
          <div class="flex-al-start" style="display: flex">
            <div class="flex-1">
              <table class="table" border="0" cellpadding="0" cellspacing="0">
                <tr>
                  <td align="left">
                    <sp-radio-group v-model="signInfo.userType" icon-type="radio" class="flex-jc-ard radio-group">
                      <sp-radio class="flex-grow radio" :value="1">{{ $l('individual') }}</sp-radio>
                      <sp-radio class="flex-grow radio" :value="2">{{ $l('Company') }}</sp-radio>
                      <!--                <span class="compDesc">{{ $l('CompanyDesc') }}</span> -->
                    </sp-radio-group>
                  </td>
                </tr>
                <tr class="row">
                  <td class="flex flex-al-center">
                    <sp-icon type="user" :size="20" />
                    <sp-input v-model.trim="signInfo.name" type="none" :width="0.9" :placeholder="$l('userId')" @change="checkUserName" />
                  </td>
                </tr>
                <tr v-if="userIdTip" class="tip">
                  <td>
                    <span>{{ $l('userIdTip') }}</span>
                  </td>
                </tr>

                <tr class="row">
                  <td class="flex flex-al-center">
                    <sp-icon type="lock" :size="20" />
                    <sp-input v-model="signInfo.password" type="none" password :width="0.9" :placeholder="$l('password')" show-password="true" @change="checkPwd" />
                  </td>
                </tr>
                <tr v-if="passwordTip" class="tip">
                  <td>
                    <span>{{ $l('passwordTip') }}</span>
                  </td>
                </tr>
                <tr class="row">
                  <td class="flex flex-al-center">
                    <sp-icon type="lock" :size="20" />
                    <sp-input v-model="signInfo.passwordConfirmation" password type="none" :width="0.9" :placeholder="$l('repeatThePassword')" show-password="true" @change="checkConfirmPwd" />
                  </td>
                </tr>
                <tr v-if="passError" class="error tip">
                  <td>
                    <span>{{ $l('passError') }}</span>
                  </td>
                </tr>
                <tr class="row">
                  <td class="flex flex-al-center">
                    <sp-icon type="shield" :size="20" />
                    <sp-input v-model="signInfo.captchaCode" type="none" :width="0.5" :placeholder="$l('verifyCode')" />
                    <!-- <sp-identify v-model="verifyCode" :content-width="120" :content-height="40" /> -->
                    <img class="pointer" :src="verifiCodeImg" width="140" height="60" @click="changeCode">
                  </td>
                </tr>
                <tr class="row">
                  <td class="flex flex-al-center">
                    <sp-icon type="email" :size="20" />
                    <sp-input v-model="signInfo.email" type="none" :width="0.9" :placeholder="$l('email')" @focus="userIdTip=true" @blur="userIdTip=false" />
                  </td>
                </tr>
                <tr v-if="emailTip" class="tip">
                  <td>
                    <span>{{ $l('emailTip') }}</span>
                  </td>
                </tr>
                <tr class="row">
                  <td class="flex flex-al-center">
                    <sp-icon type="shield" :size="20" />
                    <sp-input v-model="signInfo.vcode" type="none" :width="0.5" :placeholder="$l('vcode')" />
                    <sp-button v-if="countdown == 30" :disabled="sendEmailCodeDisabled" height="32" class="mg-t-5" @click="verificationEmailRegister">{{ $l('Send') }}</sp-button>
                    <sp-button v-else height="32" disabled class="mg-t-5" type="cancle">{{ countdown }}</sp-button>
                  </td>
                </tr>
              </table>
            </div>
            <div style="width: 200px" />
          </div>
        </div>
      </div>
      <div style="margin-right: 200px">
        <sp-button :font="20" width="1" label="log In" :height="60" circle="5" :disabled="registerDisabled" @click="logSign">
          <span v-if="type=='logIn'" class="label">{{ $l('login') }}<span class="remark">({{ $l('defaultStyle') }})</span>&nbsp;&nbsp;→</span>
          <!--          <span v-if="type=='logIn'" class="label">{{ $l('login') }}<span class="remark">({{ $l('defaultStyle') }})</span>&nbsp;&nbsp;→</span> -->
          <span v-if="type=='signUp'" class="label">{{ $l('register') }}&nbsp;&nbsp;→</span>
        </sp-button>
        <div v-if="type=='signUp'" class="confirm-service">
          <sp-radio v-model="signInfo.confirmService">
            <span class="desc pointer sp-color-2" @click.capture="ComfirmService=!ComfirmService">{{ $l('ConfirmService') }}</span>
          </sp-radio>
        </div>
        <div v-if="type=='logIn'" class="flex-jc-bt shortCuts">
          <div class="shortCut">
            <sp-button :width="1" circle="3" height="25" :label="$l('login')" />
            <sp-popover
              placement="bottom"
              :width="200"
              trigger="click"
              :show-arrow="true"
            >
              <template #reference>
                <span class="pointer popTemp sp-color-2">{{ $l('optionalInterface') }}</span>
              </template>
              <span class="pointer popTemp">loading。。。</span>
            </sp-popover>
          </div>
          <div class="shortCut">
            <sp-button :width="1" height="25" circle="3" :label="$l('login')" />
            <sp-popover
              placement="bottom"
              trigger="click"
              :show-arrow="true"
            >
              <template #reference>
                <span class="pointer popTemp sp-color-2">{{ $l('matchingResults') }}</span>
              </template>
              <ul class="option-list">
                <li><span class="pointer popTemp sp-color-hover-1">{{ $l('MT') }}</span></li>
                <li><span class="pointer popTemp sp-color-hover-1">{{ $l('CBM') }}</span></li>
                <li><span class="pointer popTemp sp-color-hover-1">{{ $l('preferredDirection') }}</span></li>
                <li><span class="pointer popTemp sp-color-hover-1">{{ $l('preferredRoute') }}</span></li>
              </ul>
            </sp-popover>
          </div>
        </div>
      </div>
    </div>
    <sp-drawer
      v-model="forgetPass"
      :width="0.2">
      <div class="dialog-content">
        <p style="text-indent:0em">Dear user:</p>

        <p style="text-indent: 0; margin-bottom: 0;">
          If you want to retrieve the password, please contact our backstage service personnel through email or telephone
        </p>
        <p style="text-indent: 0; margin: 0">pls contact us throughblw contacts :</p>
        <div>
          <div>
            <p style="margin-bottom: 0;" class="sp-color-1"><span>Email: mail.Shiplus.net</span></p>
            <p style="margin: 0px;" class="sp-color-1"><span>TEL: 023-865686</span></p>
          </div>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer flex-jc-ard">
          <sp-button type="normal" height="50" @click="forgetPass = false">{{ $l('Cancle') }}</sp-button>
          <sp-button type="primary2" height="50" @click="forgetPass = false">{{ $l('Confirm') }}</sp-button>
        </span>
      </template>
    </sp-drawer>
    <sp-drawer v-model="ComfirmService" :width="0.3">
      <template #title>
        <div class="flex-center service-title">{{ $l('serviceTitle') }}</div>
      </template>
      <div class="pd-20 service-content text-left">
        <div v-html="$l('serviceContent')" />
      </div>
    </sp-drawer>
  </div>
</template>

<script type="text/ecmascript-6">
import logAndSign from '@/request/APIs/logAndSign'
import { getLoginIdentifyCode, getregisterIdentifyCode, getVerificationEmailRegister } from '@/request/APIs/common'
// import Bus from '@/utils/EventBus'
import spButton from '@/components/common/SpButton'
import spInput from '@/components/common/SpInput'
import spIcon from '@/components/common/SpIcon'
import spPopover from '@/components/common/SpPopover'
import spRadio from '@/components/common/SpRadio'
import spDrawer from '@/components/common/SpDrawer'
import spRadioGroup from '@/components/common/SpRadioGroup'
import { ref, reactive, computed } from 'vue'
import SpMessage from '@/components/common/SpMessage'
import SpSelect from '@/components/common/SpSelect'
import { adminsSearchApi } from '@/request/APIs/company'
import SpSelectOption from '@/components/common/SpSelectOption'
export default {
  name: 'LogSignCard',
  nameSpace: 'LogAndSign',
  components: {
    SpSelectOption,
    SpSelect,
    spButton,
    spInput,
    spIcon,
    spPopover,
    spRadio,
    spDrawer,
    spRadioGroup
  },

  setup () {
    const isEnterprise = ref(false)
    const type = ref('logIn')
    const verifiCodeImg = ref('')
    const logInfo = reactive({
      account: '',
      password: '',
      captchaCode: '',
      supervisorId: '',
      supervisorPwd: '',
      dev: true
    })

    const signInfo = reactive({
      userType: 1,
      email: '',
      name: '',
      password: '',
      passwordConfirmation: '',
      captchaCode: '',
      vtoken: '',
      vcode: '',
      confirmService: ''
    })

    const verifyCode = ref('')
    let timer = null
    const countdown = ref(30)
    const forgetPass = ref(false)
    const ComfirmService = ref(false)
    const inputStyle = reactive({
      border: 0
    })

    const userIdTip = ref(false)
    const emailTip = ref(false)
    const passwordTip = ref(false)
    const passError = ref(false)

    const loginInfoC = computed({
      get: () => {
        Object.keys(this.loginInfo).forEach((p, i) => {
          if (!p.includes('Icon')) {
            this.data.push({
              name: p,
              value: this.loginInfo[p],
              preIcon: this.loginInfo.preIcons[i],
              iconSize: 10
            })
          }
        })
        return this.data
      },

      set: (value) => {

      }
    })

    function changeCode () {
      let api = getRegisterIdentifyCodes
      if (type.value === 'logIn') {
        api = getLoginIdetifyCode
      }
      api().then(res => {
        verifiCodeImg.value = res.data.img
      })
    }

    function changeType (typeInput) {
      if (type.value === typeInput) {

      } else {
        type.value = typeInput
        if (typeInput === 'logIn') {
          getLoginIdetifyCode()
        } else {
          getRegisterIdentifyCodes()
        }
      }
    }

    // 用户名验证
    function checkUserName (val) {
      const reg = /^(?=.*[a-zA-Z])[A-Za-z\d\-_]{3,36}$/
      // 密码不验证
      userIdTip.value = !reg.test(val)
    }
    // 密码验证：必须同时有大小字母和数字，长度至少为6位
    function checkPwd (val) {
      const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!~@#$%&*.,]{6,18}$/
      // 密码不验证
      passwordTip.value = !reg.test(val)
    }
    // 重复密码必须和原始密码相同
    function checkConfirmPwd (val) {
      passError.value = signInfo.password !== val
    }

    function logSign () {
      if (type.value === 'logIn') {
        const loginParams = {
          account: logInfo.account,
          password: logInfo.password,
          captchaCode: logInfo.captchaCode,
          dev: true
        }
        if (isEnterprise.value && hrAdmins.value.length !== 0) {
          if (hrAdmins.value.length > 1) {
            if (!logInfo.supervisorId || !logInfo.supervisorPwd) {
              SpMessage.error('Hr Name and HR Passwords is Require!')
            } else {
              loginParams.supervisorId = logInfo.supervisorId
              loginParams.supervisorPwd = logInfo.supervisorPwd
              logAndSign.login(loginParams).then(res => {
                if (res.code === 1) {
                  window.location.href = 'main.html#/'
                } else {
                  logInfo.captchaCode = ''
                  getLoginIdetifyCode()
                  SpMessage.error(res.message)
                }
              }).catch(() => {
                logInfo.captchaCode = ''
                getLoginIdetifyCode()
              })
            }
          } else {
            loginParams.supervisorId = logInfo.supervisorId
            logAndSign.login(loginParams).then(res => {
              if (res.code === 1) {
                window.location.href = 'main.html#/'
              } else {
                logInfo.captchaCode = ''
                getLoginIdetifyCode()
                SpMessage.error(res.message)
              }
            }).catch(() => {
              logInfo.captchaCode = ''
              getLoginIdetifyCode()
            })
          }
        } else {
          logAndSign.login(loginParams).then(res => {
            if (res.code === 1) {
              if (isEnterprise.value && hrAdmins.value.length === 0) {
                window.location.href = 'main.html#/hr/control'
              } else {
                window.location.href = 'main.html#/'
              }
            } else {
              logInfo.captchaCode = ''
              SpMessage.error(res.message)
              getLoginIdetifyCode()
            }
          }).catch(() => {
            logInfo.captchaCode = ''
            getLoginIdetifyCode()
          })
        }
      } else {
        logAndSign.register(signInfo).then(res => {
          if (res.code === 1) {
            SpMessage.success('success! Please login!')
            changeType('logIn')
          } else {
            SpMessage.error(res.message)
          }
        })
        // window.location.href = 'main.html#/'
      }
    }

    // 初始化验证码
    function getLoginIdetifyCode () {
      getLoginIdentifyCode().then(res => {
        verifiCodeImg.value = res.data?.img
      })
    }

    function getRegisterIdentifyCodes () {
      getregisterIdentifyCode().then(res => {
        verifiCodeImg.value = res.data.img
      })
    }
    // 获取注册有限验证码
    function verificationEmailRegister () {
      getTime()
      getVerificationEmailRegister({
        to: signInfo.email
      }).then(res => {
        signInfo.vtoken = res.data.token
      })
    }
    // 倒计时
    function getTime () {
      const TIME_COUNT = 30
      if (!timer) {
        countdown.value = TIME_COUNT
        timer = setInterval(() => {
          if (countdown.value > 0 && countdown.value <= TIME_COUNT) {
            countdown.value--
          } else {
            clearInterval(timer)
            timer = null
            countdown.value = 30
          }
        }, 500)
      }
    }
    getLoginIdetifyCode()

    // 验证邮箱格式，格式正确才能点击send发送邮箱验证码
    const sendEmailCodeDisabled = computed(() => {
      const reg = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      return !reg.test(signInfo.email)
    })
    // 注册按钮disabled状态：服务条款确认、密码格式
    const registerDisabled = computed(() => {
      return type.value === 'signUp' && (!signInfo.password || passwordTip.value || !signInfo.confirmService) && !userIdTip.value
    })
    const hrAdmins = ref([])
    const searchAdmins = (val) => {
      if (!val) return
      adminsSearchApi(val).then(res => {
        if (res.code === 1) {
          isEnterprise.value = res.data.isEnterprise
          hrAdmins.value = res.data.admins.admins
          logInfo.supervisorId = hrAdmins.value.length > 0 ? res.data.admins.admins[0].id : null
        } else {
          isEnterprise.value = false
        }
      })
    }
    return {
      type,
      verifiCodeImg,
      logInfo,
      signInfo,
      verifyCode,
      forgetPass,
      ComfirmService,
      inputStyle,
      userIdTip,
      emailTip,
      passwordTip,
      passError,
      loginInfoC,
      changeCode,
      checkConfirmPwd,
      logSign,
      changeType,
      verificationEmailRegister,
      countdown,
      sendEmailCodeDisabled,
      registerDisabled,
      checkPwd,
      checkUserName,
      searchAdmins,
      isEnterprise,
      hrAdmins
    }
  }
}
</script>

<style scoped lang="less">
@gap:50px;
.LogSignCard{
  width: 70%;
    overflow: hidden;
    position: relative;
    top :10px;
    > .title{
      font-size: 20px;
      font-weight: 700;
    }
    > .content{
      position: relative;
      > .input{
        width: 100%;
        height: 100%;
        padding: 30px 0 30px 0;
        .radio-group{
          @radioGap:10px;
          .radio{
            padding: @radioGap 0 @radioGap 0;
            .compDesc{
              font-size: 5px;
              padding-left: 10px;
            }
          }
        }
        .table{
          border-collapse: collapse;
          //width: 100%;
          height: 100%;
          >.row{
            border-bottom: #c0bdbd 1px solid;
            height:60px;
          }
          > .tip{
            font-size: 10px;
            color:#F0A201;
            text-align: left;
            text-indent: 3em;
            white-space: nowrap
          }
          >.error{
            color: red;
          }
          > tr > .forget{
            padding-top: 10px;
          }
        }
      }
      .label{
        font-size: 20px;
        > .remark{
          font-size: 15px;
          opacity: 0.5;
        }
      }
      .confirm-service{
        text-align: left;
        margin-top: 20px;
        >.desc{
          padding-left: 10px;
          font-size: 10px;
        }
      }
      .shortCuts{
        width: 100%;
        height: 100%;
        padding: @gap 0 @gap 0;
        opacity:0.5;
        .shortCut{
          width: 30%;
        }
      }
    }
}
.popTemp{
  font-size: 0.5vw;
}
@padding:10px;
.option-list{
  list-style-type: none;
  padding: 0 @padding 0 @padding;
}
.dialog-content{
  text-align: left;
  padding: @gap/2;
  > p{
    text-indent: 2em;
  }
  > div{
    :first-child{
      padding-right: 10px;
    }
    >div{
      vertical-align: top;
      display: inline-block;
    }
  }
}
.service-title{
  font-size: 5px;
  font-weight: 800;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px dashed #3A909D;
}
.service-content{
  font-size: 5px;
}
</style>

<style lang="less">
.hr-panel{
  position: relative;
  top: 34px;
  > div {
    > span {
      color: black;
      opacity: 0.2
    }
    .SpInput{
      position: relative;
      border: 1px dashed #3A909D;
      background: #f6f6f6;
      box-sizing: border-box;
      top: -2px;
      input {

      }
    }
    .SpSelect{
      border: 1px dashed #3A909D;
      background: #f6f6f6;
      position: relative;
      top: -4px;
    }
  }

}
.radio {
  .radio-icon {
    width: 19px !important;
  }
}
</style>
